import type { Encoding } from '@studio/js-utils/time';

/** Discovery timeout — also the legacy command re-arm interval. */
export const Timeout: Encoding.MILLISECONDS = 15e3;

/** Search Again spinner lifetime. Independent of the 15 s re-arm. */
export const KickFeedback: Encoding.MILLISECONDS = 3e3;

/** Presentation ceiling for an in-flight mutate. Does not start a second request. */
export const PresentationCeiling: Encoding.MILLISECONDS = 30e3;

/**
 * Upper bound on how long a discovery waits for an in-flight device teardown
 * on the same agent to settle before mutating (ENG-4477). The wait resolves
 * the moment the teardown settles; this cap only exists so a wedged teardown
 * cannot block discovery forever.
 */
export const TeardownWait: Encoding.MILLISECONDS = 10e3;
